import DashboardPage from "./DashboardPage";
import PlanListPage from "./plans/PlanListPage";
import SupportRequestsPage from "./support/SupportRequestsPage";
import TenantListPage from "./tenant/TenantListPage";
import TenantDetailsPage from "./tenant/TenantDetailsPage";
import TransactionsListPage from "./transaction/TransactionListPage";
import TransactionDetailsPage from "./transaction/TransactionDetailsPage";
import PlanForm from "./plans/PlanForm";
import TenantForm from "./tenant/TenantForm";
import TransactionForm from "./transaction/TransactionForm";
import SettingsPage from "./SettingsPage";
import ReportsPage from "./ReportsPage";

export interface AdminRoute {
  path: string;
  element: React.ReactElement;
  allowedRoles?: string[];
}

export const adminRoutes: AdminRoute[] = [
  { path: "/dashboard", element: <DashboardPage /> },
  { path: "/plans/create", element: <PlanForm /> },
  { path: "/plans/:planId/edit", element: <PlanForm /> },
  { path: "/plans/list", element: <PlanListPage /> },
  { path: "/support", element: <SupportRequestsPage /> },
  { path: "/tenant/create", element: <TenantForm /> },
  { path: "/tenant/:tenantId/edit", element: <TenantForm /> },
  { path: "/tenant/list", element: <TenantListPage /> },
  { path: "/tenant/:tenantId/details", element: <TenantDetailsPage /> },
  { path: "/transaction/create", element: <TransactionForm /> },
  { path: "/transaction/:transactionId/edit", element: <TransactionForm /> },
  { path: "/transaction/list", element: <TransactionsListPage /> },
  {
    path: "/transaction/:transaction_id/details",
    element: <TransactionDetailsPage />,
  },
  // { path: "/tenants/:tenantId/tenant-users", element: <TenantUsersPage /> },
  {
    path: "/settings",
    element: <SettingsPage />,
  },
  { path: "/reports", element: <ReportsPage /> },
];
